module.exports = function(vars) {
var __t, __p = '';
__p += '<li class="toolIconArchive"><span class="tooltipLeft ico action-toggle-archives"\n  title="Previous Broadcasts" data-title="Previous Broadcasts" aria-label="Watch Previous Broadcasts"><i class="fa fa-archive"></i></span></li>\n';
return __p
}


// WEBPACK FOOTER //
// ./src/templates/archiveToolBoxIcon.ejs